import {
  DataTableFilter,
  FilterType,
  ProjectManagementProjectFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import StatusTag from 'modules/project_management/components/labelTags/StatusTag'

const options = () => {
  return [
    {
      label: i18n.t('project_management.projects.status.active'),
      value: 'active',
      component: <StatusTag projectStatus={'active'} />,
    },
    {
      label: i18n.t('project_management.projects.status.draft'),
      value: 'draft',
      component: <StatusTag projectStatus={'draft'} />,
    },
    {
      label: i18n.t('project_management.projects.status.processing'),
      value: 'processing',
      component: <StatusTag projectStatus={'processing'} />,
    },
    {
      label: i18n.t('project_management.projects.status.closed'),
      value: 'closed',
      component: <StatusTag projectStatus={'closed'} />,
    },
  ]
}

export const StatusFilter = (): DataTableFilter<ProjectManagementProjectFilter> => {
  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
      },
    ],
    identifier: 'statusFilter',
    path: 'status',
    title: i18n.t('project_management.table.projects_list.headers.status'),
    default: true,
  }
}
